<template>
    <header class="sticky top-0 z-20 transition-colors duration-200"
        :class="scrolled ? 'bg-nomad-850/95 backdrop-blur' : 'bg-nomad-850'">
        <div class="flex h-16 items-center gap-3 px-4 sm:px-6 lg:px-8">
            <Link href="/" class="shrink-0 lg:hidden" aria-label="Heesify home">
                <img src="@/assets/logo-full.svg" alt="Heesify" class="-ml-1 h-12 select-none" />
            </Link>

            <div class="hidden items-center gap-2 lg:flex">
                <button type="button" @click="goBack"
                    class="flex h-8 w-8 items-center justify-center rounded-full bg-black/40 text-nomad-200 transition-colors hover:text-white"
                    aria-label="Go back">
                    <span class="icon-chevron-left" aria-hidden="true"></span>
                </button>
                <button type="button" @click="goForward"
                    class="flex h-8 w-8 items-center justify-center rounded-full bg-black/40 text-nomad-200 transition-colors hover:text-white"
                    aria-label="Go forward">
                    <span class="icon-chevron-right" aria-hidden="true"></span>
                </button>
            </div>

            <Link v-if="!$page.url.startsWith('/search')" href="/search"
                class="ml-2 hidden h-10 w-full max-w-sm items-center gap-3 rounded-full bg-white/[0.06] px-4 text-sm text-nomad-400 transition-colors hover:bg-white/[0.09] lg:flex"
                aria-label="Search">
                <span class="icon-search text-base" aria-hidden="true"></span>
                What do you want to listen to?
            </Link>

            <div class="ml-auto flex items-center gap-3">
                <button v-if="isLoggedIn && auth && auth.id" type="button" @click="openMenu"
                    class="rounded-full" aria-label="Account">
                    <img :src="auth.avatar" alt="" class="h-8 w-8 rounded-full object-cover" />
                </button>
                <button v-else type="button" @click="$store.dispatch('user/login')"
                    class="inline-flex h-9 items-center whitespace-nowrap rounded-full bg-white px-5 text-sm font-semibold text-black transition-transform hover:scale-[1.03]">
                    Log in
                </button>
            </div>
        </div>
    </header>
</template>
<script>
import { Link } from "@inertiajs/vue3";
import { mapState } from "vuex";
export default {
    components: { Link },
    emits: ["open-menu"],
    data() {
        return { scrolled: false };
    },
    computed: {
        ...mapState({
            auth: (state) => state.user.auth,
            isLoggedIn: (state) => state.user.isLoggedIn,
        }),
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll, { passive: true });
        this.onScroll();
    },
    beforeUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    },
    methods: {
        onScroll() {
            this.scrolled = window.scrollY > 8;
        },
        goBack() {
            window.history.back();
        },
        goForward() {
            window.history.forward();
        },
        openMenu() {
            this.$emit("open-menu");
        },
    },
};
</script>
